// extracted by mini-css-extract-plugin
export var component = "SearchStats-module--component--f01e1";
export var fadePop = "SearchStats-module--fade-pop--b7f2a";
export var growHeightIn = "SearchStats-module--grow-height-in--58afe";